import React from "react";
import styled from "styled-components";
import NanoFlex from "../Global/NanoFlex.js";

//Imgs
import { ReactComponent as ArrowLeft } from "./../Global/icons/arrowRight.svg";

const StyledLinkButton = styled(NanoFlex)`
  height: auto;
  width: auto;
  margin: 0px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  .buttonWrapper {
    display: flex;
    align-items: center;
    width: auto;
    overflow: hidden;
    padding: 0;
    font-family: ${(props) => props.theme.font};
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 18px;
    user-select: none;
    cursor: pointer;
    text-decoration: none;
    color: ${(props) => props.theme.color.primaryColors.fontColor};
    user-select: none;
    text-transform: none;
    gap: 10px;
    font-weight: normal !important;

    p {
      transition: ${(props) => props.theme.transition};
    }

    svg {
      transition: ${(props) => props.theme.transition};
    }

    /* MEDIA QUERIES */

    @media only screen and (max-width: 1450px) {
      font-size: 14px;
    }

    @media only screen and (max-width: 1024px) {
      font-size: 12px;
    }

    &:hover {
      color: ${(props) => props.theme.color.primaryColors.darkPurple};
      transition: ${(props) => props.theme.transition};

      svg {
        path {
          stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
          transition: ${(props) => props.theme.transition};
        }
      }
    }

    &:focus,
    &:focus-visible {
      color: ${(props) => props.theme.color.primaryColors.darkPurple};
      text-decoration: underline;

      svg {
        path {
          stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
        }
      }
    }
    &:disabled,
    &.disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }
`;

const LinkButton = (props) => {
  return (
    <StyledLinkButton className="button" orange={props.orange} disabled={props.disabled}>
      <button className="buttonWrapper" type={props.type} onClick={() => props.clickAction(props.id)}>
        {props.label}
        <ArrowLeft />
      </button>
    </StyledLinkButton>
  );
};

// Set default props
LinkButton.defaultProps = {
  id: 0,
  label: "",
  type: "submit",

  clickAction: () => null,
};

export default LinkButton;
